import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { applySort } from '../../actions/sort/applySort';
import { ISortDropdownOption, SortDropdown } from '../../components/SortDropdown';
import { EKey } from '../../repositories/dailyrent/entities/sort_variant/SortVariant';
import { selectActiveSortKey } from '../../selectors/filters/selectActiveSortKey';
import { selectSortVariants } from '../../selectors/listingOffers/selectSortVariants';
import { TThunkDispatch } from '../../types/redux';
import { getSortOptions } from '../../utils/sort/getSortOptions';
import { TSortKey } from '../../utils/sort/sortMapping';

const DEFAULT_OPTIONS: ISortDropdownOption[] = [{ key: EKey.Default, label: 'По умолчанию' }];

export interface ISortContainerProps {
  className?: string;
}

export const SortContainer: React.FC<ISortContainerProps> = ({ className }) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();
  const sortVariants = useSelector(selectSortVariants);
  const hasSortVariants = sortVariants && sortVariants.length > 0;
  const activeKey = useSelector(selectActiveSortKey);

  const options = React.useMemo(
    () => (hasSortVariants ? getSortOptions(sortVariants) : DEFAULT_OPTIONS),
    [sortVariants, hasSortVariants],
  );

  const handleChange = React.useCallback(
    (key: TSortKey) => {
      dispatch(applySort({ sortKey: key, deviceType }));
    },
    [dispatch, deviceType],
  );

  return <SortDropdown options={options} value={activeKey} className={className} onChange={handleChange} />;
};

SortContainer.displayName = 'SortContainer';
